// extracted by mini-css-extract-plugin
export default {"wrapper":"Payment_wrapper__vODBJ","title":"Payment_title__o95jl","titleWrapper":"Payment_titleWrapper__YMZf8"};